var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisa = function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M4.144 10 2 14.956h2.567l.318-.79h.728l.318.79h2.826v-.603l.251.603h1.462l.252-.616v.616h5.876l.715-.77.669.77 3.018.006-2.151-2.47L21 10h-2.971l-.696.755-.648-.755h-6.393l-.549 1.28L9.181 10H6.62v.582L6.335 10zm8.776.704h3.374l1.032 1.164 1.066-1.164h1.032l-1.569 1.787 1.569 1.767h-1.08l-1.031-1.178-1.071 1.178H12.92zm.833 1.385v-.649h2.105l.92 1.037-.96 1.044h-2.065v-.708h1.84v-.724zM4.64 10.704h1.251l1.423 3.36v-3.36h1.37l1.099 2.41 1.012-2.41h1.364v3.556h-.83l-.006-2.787-1.21 2.787H9.37l-1.216-2.787v2.787H6.447l-.323-.797H4.375l-.323.796h-.915zm.033 2.021.576-1.42.575 1.42z",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 16,
    x: 0.5,
    y: 3.5,
    fill: "#fff",
    stroke: "#D9D9D9",
    rx: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#172B85",
    fillRule: "evenodd",
    d: "M7.33 14.516H5.878l-1.09-4.296c-.052-.198-.162-.373-.324-.455A4.6 4.6 0 0 0 3.13 9.31v-.165h2.343c.323 0 .565.248.606.537l.565 3.1 1.454-3.637H9.51zm2.99 0H8.945l1.13-5.371h1.374zm2.906-3.883c.04-.29.283-.455.566-.455.445-.042.929.042 1.333.248l.242-1.157a3.4 3.4 0 0 0-1.252-.248c-1.332 0-2.302.744-2.302 1.776 0 .786.687 1.198 1.172 1.447.524.248.726.413.686.661 0 .372-.404.537-.807.537a3.4 3.4 0 0 1-1.414-.33l-.242 1.156c.484.207 1.009.29 1.494.29 1.494.04 2.423-.703 2.423-1.818 0-1.405-1.899-1.488-1.899-2.107m6.704 3.883-1.09-5.371h-1.17a.61.61 0 0 0-.567.413l-2.019 4.958h1.414l.282-.785h1.737l.162.785zm-2.059-3.925.404 2.025h-1.131z",
    clipRule: "evenodd"
  })));
};
export default SvgVisa;